import React, { useState, useEffect } from 'react';

const SliderHandle = props => {
	const { reportProgress, initialProgress } = props;
	const [progress, setProgress] = useState(initialProgress || 0.17);
	function throttled(fn, delay) {
		let lastCall = 0;
		return (...args) => {
			const now = (new Date()).getTime();
			if (now - lastCall < delay) {
				return;
			}
			lastCall = now;
			fn(...args);
		};
	}
	useEffect(() => {
		const { selector, fixed } = props;
		const area = document.querySelector(selector);
		function onMouseMove(event) {
			event.preventDefault();
			const prog = Math.max(0, Math.min(1, event.pageX / document.body.clientWidth));
			setProgress(prog);
			if (reportProgress && typeof reportProgress === 'function') {
				reportProgress({ left: prog, x: event.pageX });
			}
		}
		const throttledMouseMove = throttled(onMouseMove, 30);
		if (fixed === false) {
			area.addEventListener('mousemove', throttledMouseMove);
		}
		return () => {
			area.removeEventListener('mousemove', throttledMouseMove);
		};
	}, []);

	return (
		<div className="slider-handle" style={{ left: `${100 * progress}%` }} />
	);
};

export default SliderHandle;



// WEBPACK FOOTER //
// ./src/components/image-compare/SliderHandle.js